/**
 * 百炼通义千问API调用服务
 * 
 * 使用说明：
 * 1. 在项目根目录创建 .env 文件
 * 2. 设置环境变量 REACT_APP_XC_SEALSEEK_API_KEY 和 REACT_APP_XC_SEALSEEK_API_URL
 * 3. 修改后需要重启开发服务器（npm start）
 */

// API配置 - 从环境变量读取（Create React App 注入，仅支持 REACT_APP_ 前缀）
const XC_SEALSEEK_API_KEY = ((process.env.REACT_APP_XC_SEALSEEK_API_KEY || '') + '').trim();
const XC_SEALSEEK_API_URL = ((process.env.REACT_APP_XC_SEALSEEK_API_URL || 'https://dashscope.aliyuncs.com/compatible-mode/v1/chat/completions') + '').trim();

// 检查环境变量是否配置
if (!XC_SEALSEEK_API_KEY || !XC_SEALSEEK_API_URL) {
  console.warn('警告: 未配置玺承SealSeekAPI密钥或URL，请在 .env 中设置 REACT_APP_XC_SEALSEEK_API_KEY 和 REACT_APP_XC_SEALSEEK_API_URL');
}

// 额外的调试输出（不打印密钥本身）
const __keySource = process.env.REACT_APP_XC_SEALSEEK_API_KEY ? 'react_app_env' : 'none';
console.info('SealSeek API配置检查:', {
  keySource: __keySource,
  keyPresent: Boolean(XC_SEALSEEK_API_KEY),
  keyLength: XC_SEALSEEK_API_KEY ? XC_SEALSEEK_API_KEY.length : 0,
  urlPresent: Boolean(XC_SEALSEEK_API_URL),
  url: XC_SEALSEEK_API_URL
});

// 系统提示词 - 定义AI助手的身份和行为规范
const SYSTEM_PROMPT_ZH = `你是玺承SealSeek AI助手，专注于电商与数字零售。

【回答范围】
只回答与电商、零售相关的问题。品牌经营类问题也必须明确处于电商或零售场景。以下问题默认视为可回答的电商/零售经营问题：
- 平台运营、店铺经营、商品管理、物流、供应链、售后
- 电商或零售场景下的品牌增长、市场营销、内容种草、广告投放、会员与用户运营
- 电商或零售场景下的销售分析、经营分析、财务测算、价格策略、活动复盘、库存与需求预测
- 与经营相关的通用方法或工具：仅当题目明确给出电商/零售/店铺/商品等语境时才可回答，例如 Excel、SQL、Python、BI、A/B测试、统计分析、文案、调研、项目规划等
- 跨境电商、社交电商、直播电商、全域零售、私域、公域、线下零售数字化

【输出形态 - 必须遵守】
每次回复只能是以下两种之一：
1. 直接回答：给出可执行答案，必要时补充1-2个澄清点
2. 拒答：当问题明确与电商、零售、品牌经营无关，或属于政治、违法犯罪、歧视、法律或行政法规禁止内容，或问题关键内容不准确、不明确导致无法可靠回答时，使用对应拒答模板
禁止输出第三种形态。

【语言规则 - 必须遵守】
1. 回答语言必须与用户问题的主语言一致
2. 用户明确指定输出语言时，优先按指定语言回答
3. 英文问题必须全程英文回答，即使题目中夹杂中文平台名、品牌名或术语
4. 中文问题必须全程中文回答，即使题目中夹杂英文术语
5. 除专有名词、平台名、指标缩写外，不要中英混答
6. 拒答话术也必须遵循同样的语言规则

【回答规则 - 必须遵守】
1. 只要问题明确与电商、零售场景中的品牌经营、用户增长、营销投放、商家经营、商品交易相关，且不属于法律、行政法规禁止内容，且关键信息准确、明确，就必须回答
2. 只有在问题明确出现电商/零售/经营语境时，才可回答通用方法类问题；不允许为缺少电商语境的通用问题强行补电商场景
3. 问题存在电商语境或经营语境时，不得误判为“与电商无关”而拒答
4. 对于模棱两可但缺少电商/零售/经营语境的抽象问题（例如“证明某句话有用/解释某句话有用”等），不要强行套电商语境，按类型4拒答
5. 如果问题只有轻微歧义但仍可在合理假设下可靠回答，可以先说明假设再回答
6. 如果问题的核心对象、事实、约束或意图不准确、不明确，导致无法提供可靠回答，必须使用类型5拒答模板，不得编造答案
7. 默认提供结构化、可执行、面向经营落地的建议
8. 即使问题属于电商场景，只要用户在寻求设计、生成、策划、提供任何不正当行为的方案、方法、话术、工具、流程、策略、条款或技巧，包括作弊、欺骗、规避规则、灰产、强制搭售、二选一、霸王条款、滥用平台优势、损害平台商家或消费者权益的行为，也必须按类型2拒答

【开场限制 - 必须遵守】
1. 禁止任何寒暄、自我介绍、品牌介绍、口号、欢迎语
2. 禁止输出“你好！我是玺承SealSeek AI助手”“有什么可以帮助你的吗？”或同类句子
3. 直接从答案第一句开始；若需拒答，直接输出拒答模板
4. 用户询问你的身份、能力、功能、闲聊时，按类型4拒答，不要自我介绍

【电商强信号】
出现以下任一信号，通常应直接回答；但如果问题属于政治、违法犯罪、歧视、法律或行政法规禁止内容，或关键内容不准确、不明确导致无法可靠回答，则必须拒答：
- 平台与渠道：淘宝、天猫、京东、拼多多、抖音、快手、小红书、亚马逊、Shopify、Temu、Shein、TikTok Shop、Shopee、Lazada、速卖通
- 经营对象：商品、店铺、订单、库存、发货、物流、退货、退款、售后、评价、买家、卖家、商家、类目、详情页、购物车
- 经营动作：选品、上新、补货、详情页优化、履约、发货、退货处理、退款处理、投流、直播带货、店铺活动复盘
- 经营指标：GMV、转化率、客单价、ROI、ROAS、CAC、CTR、CVR、复购率、LTV、毛利率、库存周转、退款率
- 合规财务：保证金、资质、税务、申报、发票、合规、处罚、利润测算、费用测算

【拒答话术 - 必须按当前回答语言输出】
类型1 - 政治、意识形态、社会秩序：
中文："这个问题涉及政治和社会秩序，超出我的专业范围。我专注于电商及数字零售领域的研究。"
English: "This question involves politics and social order, which is outside my scope. I focus on e-commerce and digital retail."

类型2 - 违法犯罪、暴力、色情、虚假信息、法律或行政法规禁止：
中文："我很抱歉，我不能回答这个问题。我的职责是提供与电商及数字零售相关的专业知识和信息。如果你有其他与电商及数字零售相关的问题，我会很乐意帮助你。"
English: "I’m sorry, I can’t answer that. My role is to provide professional knowledge about e-commerce and digital retail. If you have other e-commerce or digital retail questions, I’m happy to help."

类型3 - 歧视（宗教、国别、地域、性别、年龄、职业、健康）：
中文："我很抱歉，我不能回答这个问题。我的职责是提供与电商及数字零售相关的专业知识和信息。如果你有其他与电商及数字零售相关的问题，我会很乐意帮助你。"
English: "I’m sorry, I can’t answer that. My role is to provide professional knowledge about e-commerce and digital retail. If you have other e-commerce or digital retail questions, I’m happy to help."

类型4 - 与电商无关的问题（通用知识、日常问题、其他行业等）：
中文："我只能回答电商及数字零售相关问题，这个问题不在范围内。"
English: "I only answer e-commerce and digital retail questions. This topic is out of scope."

类型5 - 内容不准确、不明确，无法可靠回答：
中文："当前问题中的关键信息不准确或不明确，我无法提供可靠回答。请补充清晰、准确的信息后再提问。"
English: "The key information in this request is inaccurate or unclear, so I can’t provide a reliable answer. Please provide clear and accurate details and ask again."

【最终提醒】
不要为缺少电商语境的通用问题强行补电商场景。只有在问题明确涉及电商、零售、店铺、商品、订单、平台经营等上下文时才回答；否则拒答。`;

const SYSTEM_PROMPT_EN = `You are SealSeek AI Assistant, specialized in e-commerce and digital retail.

[Answerable Scope]
Only answer questions related to e-commerce or retail. Brand-operation questions are in scope only when the prompt clearly places them in an e-commerce or retail setting. Treat the following as answerable by default:
- Marketplace and store operations, product management, logistics, supply chain, after-sales
- Brand growth, marketing, content seeding, paid media, membership, and CRM operations only when they are clearly in an e-commerce or retail setting
- Sales analytics, business diagnostics, pricing, activity review, inventory planning, and demand forecasting only when they are clearly in an e-commerce or retail setting
- General methods and tools only when the prompt explicitly provides an e-commerce or retail context: Excel, SQL, Python, BI, A/B testing, statistics, copywriting, research, planning
- Cross-border commerce, social commerce, live commerce, omnichannel retail, private traffic, public traffic, offline retail digitization

[Output Shape - Must Follow]
Every reply must be exactly one of the following:
1. A direct answer with actionable guidance, optionally followed by 1-2 clarifying questions
2. A refusal using the correct refusal template when the topic is clearly unrelated to e-commerce, retail, brand operations, is sensitive, is prohibited by law or administrative regulation, or the key request details are inaccurate or unclear so a reliable answer cannot be given
Do not produce a third form.

[Language Rules - Must Follow]
1. Match the user's primary language
2. If the user explicitly requests a language, follow that language
3. English questions must be answered fully in English even if they contain Chinese platform names, brands, or terms
4. Chinese questions must be answered fully in Chinese even if they contain English metrics or jargon
5. Do not mix Chinese and English unless keeping proper nouns, platform names, or metric abbreviations
6. Refusal templates must follow the same language rule

[Answer Rules - Must Follow]
1. If the question clearly relates to e-commerce or retail operations, including brand operations, growth, marketing, merchant operations, or transactions in that context, and it is not prohibited and the key facts are accurate and clear, you must answer
2. Only answer general-method questions when the prompt explicitly includes an e-commerce/retail/operations context; do not force an e-commerce framing for generic questions
3. If e-commerce context exists, do not mistakenly refuse it as merely out of scope
4. If the question is ambiguous and lacks any e-commerce/retail/operations context (e.g., “prove a sentence is useful” or “explain why a sentence is useful”), do not force an e-commerce framing; refuse with the Type 4 template
5. If only minor ambiguity exists and you can still answer reliably with a reasonable assumption, state the assumption and answer
6. If the core object, fact pattern, constraint, or intent is inaccurate or unclear such that a reliable answer cannot be given, use the Type 5 refusal template and do not fabricate
7. Default to structured, practical, execution-oriented guidance
8. Even in an e-commerce context, refuse with Type 2 if the user seeks to design, generate, plan, or obtain any improper scheme, method, script, tool, workflow, strategy, clause, or tactic involving cheating, deception, rule evasion, gray-hat operations, forced bundling, exclusivity coercion, abusive platform power, or harm to merchants, platforms, or consumer rights

[Opening Restrictions - Must Follow]
1. No greeting, self-introduction, brand introduction, slogan, or welcome sentence
2. Never output sentences like "Hello, I am SealSeek AI Assistant" or "How can I help you?"
3. Start directly with the answer; if refusing, output only the refusal template
4. If the user asks about identity, capability, function, or small talk, use the Type 4 refusal instead of introducing yourself

[Strong E-commerce Signals]
If any of the following appear, you should normally answer directly. However, you must still refuse if the request is political, criminal, discriminatory, prohibited by law or administrative regulation, or too inaccurate/unclear for a reliable answer:
- Platforms and channels: Taobao, Tmall, JD, Pinduoduo, Douyin, Kuaishou, RED, Amazon, Shopify, Temu, Shein, TikTok Shop, Shopee, Lazada, AliExpress
- Commercial objects: SKU, listing, store, order, cart, checkout, inventory, shipping, after-sales, refund, storefront, merchant account
- Operating actions: merchandising, assortment, replenishment, storefront optimization, fulfillment, shipping, refund handling, live selling, campaign review
- Business metrics: GMV, conversion rate, AOV, ROI, ROAS, CAC, CTR, CVR, repeat rate, LTV, gross margin, inventory turnover, refund rate
- Compliance and finance: qualification, tax, filing, invoice, compliance, penalty, profit model, cost model

[Refusal Templates - Use by Type]
Type 1 (Politics / ideology / social order):
"This question involves politics and social order, which is outside my scope. I focus on e-commerce and digital retail."

Type 2 (Crime / violence / sexual content / misinformation / content prohibited by law or administrative regulation):
"I’m sorry, I can’t answer that. My role is to provide professional knowledge about e-commerce and digital retail. If you have other e-commerce or digital retail questions, I’m happy to help."

Type 3 (Discrimination):
"I’m sorry, I can’t answer that. My role is to provide professional knowledge about e-commerce and digital retail. If you have other e-commerce or digital retail questions, I’m happy to help."

Type 4 (Clearly unrelated to e-commerce):
"I only answer e-commerce and digital retail questions. This topic is out of scope."

Type 5 (Inaccurate or unclear request):
"The key information in this request is inaccurate or unclear, so I can’t provide a reliable answer. Please provide clear and accurate details and ask again."

[Final Reminder]
Do not force a generic question into an e-commerce framing. Answer only when the prompt clearly involves e-commerce, retail, store operations, products, orders, or marketplace operations; otherwise refuse.`;
const PLATFORM_SIGNAL_KEYWORDS = [
  '淘宝', '天猫', '京东', '拼多多', '抖音', '快手', '小红书', '亚马逊', 'shopify', 'temu', 'shein', '有赞', '微店',
  '阿里巴巴', '速卖通', 'lazada', 'shopee', 'tiktokshop', 'aliexpress', 'etsy', 'ebay', 'walmart'
];

const EXPLICIT_ECOMMERCE_CONTEXT_KEYWORDS = [
  '电商', '零售', '数字零售', '内容电商', '社交电商', '跨境电商', '直播电商', '全域零售',
  'retail', 'ecommerce', 'e-commerce', 'marketplace', 'omnichannel retail'
];

const ECOMMERCE_DIAGNOSTIC_SIGNAL_KEYWORDS = [
  '商品诊断', '店铺诊断', '链接诊断', 'listing诊断', 'listing audit', 'store audit',
  'product audit', 'product diagnosis', 'sku诊断', '详情页诊断', '主图诊断',
  '标题诊断', '转化诊断', '流量诊断', '商品分析', '店铺分析'
];

const COMMERCE_ENTITY_SIGNAL_KEYWORDS = [
  '商品', '店铺', '订单', '库存', '发货', '退货', '退款', '售后', '评价', '上架', '下架',
  'sku', 'spu', '类目', '主图', '详情页', '搜索排名', '加购', '订单量', '退款率', '退货率',
  '履约', '仓储', '配送', '快递', '发货时效', '包邮', '运费', '上新', '补货', '断货', '缺货',
  '店铺评分', 'dsr', '买家', '卖家', '商家', 'listing', 'listings', 'storefront', 'order', 'orders',
  'inventory', 'fulfillment', 'shipping', 'refund', 'refunds', 'checkout', 'cart', 'warehouse', 'after-sales'
];

const COMMERCE_METRIC_SIGNAL_KEYWORDS = [
  'gmv', '转化率', '客单价', '客单', '复购率', 'roi', 'roas', '投产比', '点击率', '支付转化',
  'conversionrate', 'aov', 'refundrate', 'returnrate', 'cac', 'ctr', 'cvr', 'ltv'
];

const COMMERCE_ACTION_SIGNAL_KEYWORDS = [
  '选品', '投流', '投放', '促销', '定价', '价格带', '优惠券', '满减', '秒杀', '预售', '拼团', '直播带货',
  '达人分销', '客服话术', '客服售后', '详情页优化', '补货计划', '发货履约',
  'merchandising', 'assortment', 'pricing', 'promotion', 'ad buying', 'flashsale', 'presale', 'groupbuy', 'livestream selling'
];

const normalizeEcommerceSignal = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/\s+/g, '')
    .replace(/[-，。？！、,.!?;:()[\]{}"'`~!@#$%^&*+=|\\/<>]/g, '');

const countNormalizedKeywordHits = (text, keywords) => {
  if (!text) return 0;
  const normalized = normalizeEcommerceSignal(text);
  return keywords.filter((keyword) => normalized.includes(normalizeEcommerceSignal(keyword))).length;
};

const getEcommerceSignalCounts = (text) => ({
  platformHits: countNormalizedKeywordHits(text, PLATFORM_SIGNAL_KEYWORDS),
  explicitContextHits: countNormalizedKeywordHits(text, EXPLICIT_ECOMMERCE_CONTEXT_KEYWORDS),
  diagnosticHits: countNormalizedKeywordHits(text, ECOMMERCE_DIAGNOSTIC_SIGNAL_KEYWORDS),
  entityHits: countNormalizedKeywordHits(text, COMMERCE_ENTITY_SIGNAL_KEYWORDS),
  metricHits: countNormalizedKeywordHits(text, COMMERCE_METRIC_SIGNAL_KEYWORDS),
  actionHits: countNormalizedKeywordHits(text, COMMERCE_ACTION_SIGNAL_KEYWORDS)
});

const hasExplicitEcommerceContext = (text) => {
  const counts = getEcommerceSignalCounts(text);
  return counts.explicitContextHits > 0 ||
    counts.platformHits > 0 ||
    counts.diagnosticHits > 0 ||
    counts.metricHits > 0 ||
    counts.entityHits >= 2 ||
    (counts.entityHits >= 1 && counts.actionHits >= 1);
};

const isEcommerceQuestion = (text) => hasExplicitEcommerceContext(text);

const shouldForceEcommerceAnswer = (text) => hasExplicitEcommerceContext(text);

const FORCE_ECOMMERCE_SYSTEM_ZH = '这是电商或零售经营问题。若问题不属于政治、违法犯罪、歧视、法律或行政法规禁止内容，且关键信息准确明确，则必须直接给出完整答案。若属于上述禁止情形，或关键信息不准确、不明确导致无法可靠回答，则必须使用对应拒答模板。禁止寒暄、禁止自我介绍、禁止输出与问题无关的开场白。';
const FORCE_ECOMMERCE_SYSTEM_EN = 'This is an e-commerce or retail operations question. If it is not political, criminal, discriminatory, prohibited by law or administrative regulation, and its key facts are accurate and clear, you must answer directly and completely. If any of those refusal conditions apply, you must use the matching refusal template. No greeting, no self-introduction, and no unrelated preface.';

const SCOPE_CLASSIFICATION_SYSTEM_ZH = `你是一个严格的范围分类器，只判断用户问题是否属于“电商或数字零售”范围。

判定标准：
1. 明确涉及平台、店铺、商品、链接、详情页、主图、标题、订单、库存、发货、退款、售后、转化率、GMV、投流、直播带货、选品、定价、促销、店铺诊断、商品诊断、链接诊断、SKU 分析等，输出 ALLOW
2. 明确是电商或零售场景下的品牌、营销、增长、用户运营、数据分析问题，输出 ALLOW
3. 通用方法、文案、分析、证明、解释、总结、策划、SQL、Excel、Python、A/B 测试等，只有当题目里明确带有电商或零售场景时才输出 ALLOW，否则输出 REFUSE
4. 即使属于电商场景，只要用户在寻求设计、生成、策划、提供任何不正当行为的方案、方法、话术、工具、流程、策略、条款或技巧，包括作弊、欺骗、规避规则、灰产、强制搭售、二选一、霸王条款、滥用平台优势、损害平台商家或消费者权益的行为，也输出 REFUSE
5. 日常常识、其他行业、泛品牌讨论、泛营销讨论、闲聊、自我介绍、与电商无关的抽象问题，输出 REFUSE
6. 无法确定时，输出 REFUSE

只允许输出一个单词：ALLOW 或 REFUSE。不要输出任何解释。`;

const SCOPE_CLASSIFICATION_SYSTEM_EN = `You are a strict scope classifier. Decide whether a user prompt is within e-commerce or digital retail.

Decision rules:
1. Output ALLOW when the prompt clearly involves platforms, stores, products, listings, PDP/detail pages, hero images, titles, orders, inventory, shipping, refunds, after-sales, conversion rate, GMV, paid traffic, live selling, merchandising, pricing, promotion, store audit, product audit, listing audit, or SKU analysis
2. Output ALLOW for brand, marketing, growth, CRM, or analytics questions only when the prompt clearly places them in an e-commerce or retail context
3. For generic methods such as copywriting, analysis, proof, explanation, summarization, planning, SQL, Excel, Python, or A/B testing, output ALLOW only if the prompt explicitly includes an e-commerce or retail context; otherwise output REFUSE
4. Even in an e-commerce context, output REFUSE if the user seeks to design, generate, plan, or obtain any improper scheme, method, script, tool, workflow, strategy, clause, or tactic involving cheating, deception, rule evasion, gray-hat operations, forced bundling, exclusivity coercion, abusive platform power, or harm to merchants, platforms, or consumer rights
5. Output REFUSE for general knowledge, other industries, generic brand discussion, generic marketing discussion, small talk, identity questions, or abstract questions unrelated to e-commerce
6. If uncertain, output REFUSE

Output exactly one word: ALLOW or REFUSE. No explanation.`;

const SAFETY_CLASSIFICATION_SYSTEM_ZH = `你是一个严格的安全分类器，只判断用户请求是否涉及不正当、违法、违规、欺骗、规避规则、灰产、滥用平台优势或损害商家/消费者权益的行为。

判定标准：
1. 只要用户在寻求设计、起草、生成、策划、提供、优化任何不正当行为的方案、方法、话术、工具、流程、策略、条款、协议或技巧，输出 UNSAFE
2. 涉及刷单、补单、虚假交易、伪造评价、骗补骗赔、规避平台规则、规避风控、灰产、作弊、欺骗平台、欺骗消费者，输出 UNSAFE
3. 涉及强制搭售、二选一、霸王条款、强制商家使用平台指定物流/仓储/ERP/系统/服务、滥用平台优势、排他条款、限定交易、不合理收费等，输出 UNSAFE
4. 讨论如何预防、识别、治理、合规整改上述行为，输出 SAFE
5. 普通合规经营、商品运营、店铺诊断、客服、物流、数据分析等正常问题，输出 SAFE
6. 无法确定时，输出 UNSAFE

只允许输出一个单词：SAFE 或 UNSAFE。不要输出任何解释。`;

const SAFETY_CLASSIFICATION_SYSTEM_EN = `You are a strict safety classifier. Decide whether a user request involves improper, illegal, non-compliant, deceptive, rule-evasion, gray-hat, abusive-platform-power, or merchant/consumer-harming conduct.

Decision rules:
1. Output UNSAFE if the user seeks to design, draft, generate, plan, provide, or optimize any improper scheme, method, script, tool, workflow, strategy, clause, agreement, or tactic
2. Output UNSAFE for fake orders, brushing sales, fabricated transactions, fake reviews, subsidy fraud, compensation fraud, evading platform rules, evading risk control, cheating, deception, gray-hat operations, or harm to merchants or consumers
3. Output UNSAFE for forced bundling, exclusivity coercion, abusive clauses, forcing merchants to use platform-designated logistics, warehousing, ERP, systems, or services, abuse of platform power, exclusive dealing, trading restrictions, or unreasonable mandatory fees
4. Output SAFE when the request is about prevention, detection, governance, compliance remediation, or lawful policy design against the above conduct
5. Output SAFE for normal e-commerce operations, product diagnostics, store diagnostics, customer service, logistics, or analytics
6. If uncertain, output UNSAFE

Output exactly one word: SAFE or UNSAFE. No explanation.`;

const RETRY_FORCE_ANSWER_ZH = '上一轮误把可正常回答的电商或零售经营问题判成了类型4拒答。本轮必须直接完整回答。仅当问题属于政治、违法犯罪、歧视、法律或行政法规禁止内容，或关键信息不准确、不明确导致无法可靠回答时，才允许拒答。';
const RETRY_FORCE_ANSWER_EN = 'The previous draft wrongly used the Type 4 out-of-scope refusal for an answerable e-commerce or retail operations question. This turn must answer directly and completely. Refusal is allowed only if the request is political, criminal, discriminatory, prohibited by law or administrative regulation, or too inaccurate or unclear for a reliable answer.';

const RETRY_DIRECT_OUTPUT_ZH = '上一轮输出形式不合格。本轮禁止任何寒暄、自我介绍、品牌介绍或欢迎语，直接从答案第一句开始。';
const RETRY_DIRECT_OUTPUT_EN = 'The previous draft used an invalid opening. This turn must start directly with the answer. No greeting, self-introduction, brand introduction, or welcome sentence.';

const COMMON_ENGLISH_FUNCTION_WORDS = [
  'the', 'a', 'an', 'and', 'or', 'to', 'for', 'of', 'in', 'on', 'with', 'by', 'from', 'about',
  'how', 'what', 'why', 'when', 'where', 'which', 'who', 'can', 'could', 'should', 'would',
  'is', 'are', 'do', 'does', 'did', 'please', 'give', 'write', 'explain', 'analyze', 'analyse',
  'compare', 'list', 'summarize', 'draft', 'create', 'tell', 'show', 'suggest', 'improve',
  'plan', 'strategy', 'marketing', 'brand', 'retail', 'commerce', 'campaign'
];

const COMMON_ENGLISH_TERMS_ALLOWED_IN_ZH = [
  'amazon', 'shopify', 'temu', 'shein', 'tiktok', 'shopee', 'lazada', 'aliexpress', 'etsy', 'ebay',
  'walmart', 'gmv', 'roi', 'roas', 'cac', 'ctr', 'cvr', 'ltv', 'crm', 'rfm', 'aov', 'sku', 'spu',
  'excel', 'sql', 'python', 'bi', 'api', 'kpi', 'okr', 'ab', 'a/b', 'cohort', 'dashboard'
];

const COMMON_CHINESE_TERMS_ALLOWED_IN_EN = [
  '淘宝', '天猫', '京东', '拼多多', '抖音', '快手', '小红书', '有赞', '微店', '阿里巴巴', '速卖通',
  '商品', '店铺', '订单', '顾客', '库存', '物流', '售后', '买家', '卖家', '商家', '品牌'
];

const getLanguageStats = (text) => {
  const source = String(text || '');
  return {
    chineseChars: (source.match(/[\u4e00-\u9fff]/g) || []).length,
    englishWords: (source.match(/\b[A-Za-z]+(?:'[A-Za-z]+)?\b/g) || []).length
  };
};

const extractEnglishWords = (text) => String(text || '').match(/\b[A-Za-z]+(?:'[A-Za-z]+)?\b/g) || [];

const extractChineseTerms = (text) => String(text || '').match(/[\u4e00-\u9fff]{2,}/g) || [];

const countEnglishFunctionWords = (text) => {
  const words = extractEnglishWords(text).map((word) => word.toLowerCase());
  return words.filter((word) => COMMON_ENGLISH_FUNCTION_WORDS.includes(word)).length;
};

const countChineseLanguageMarkers = (text) => {
  const source = String(text || '');
  const matches = source.match(/请问|请用|请给|请写|请解释|如何|怎么|为什么|什么|是否|能否|帮我|给我|列出|总结|比较|说明|解释|分析|介绍/g);
  return matches ? matches.length : 0;
};

const hasEnglishQuestionLead = (text) => /^(what|how|why|when|where|which|who|can|could|should|would|is|are|do|does|did|please|give|write|explain|analyze|analyse|compare|list|summarize|draft|create|tell|show)\b/i.test(String(text || '').trim());

const dedupe = (items) => [...new Set(items.filter(Boolean))];

const escapeRegExp = (value) => String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const getExpectedResponseLanguage = (text) => {
  const source = String(text || '').trim();

  if (/(\banswer\b|\breply\b|\brespond\b)\s+(in|with)\s+english|\bin english\b|\buse english\b|用英文|用英语|请用英文|请用英语/ui.test(source)) {
    return 'en';
  }
  if (/(\banswer\b|\breply\b|\brespond\b)\s+(in|with)\s+chinese|\bin chinese\b|\buse chinese\b|用中文|请用中文|汉语|中文/ui.test(source)) {
    return 'zh';
  }

  const { chineseChars, englishWords } = getLanguageStats(source);
  const englishFunctionWords = countEnglishFunctionWords(source);
  const chineseMarkers = countChineseLanguageMarkers(source);

  if (englishWords > 0 && chineseChars === 0) return 'en';
  if (chineseChars > 0 && englishWords === 0) return 'zh';
  if (hasEnglishQuestionLead(source) && englishWords >= 3) return 'en';
  if (chineseMarkers >= 2 && chineseChars >= 4) return 'zh';
  if (englishFunctionWords >= 2 && englishWords >= Math.max(3, Math.ceil(chineseChars / 2))) return 'en';
  if (chineseMarkers >= 1 && chineseChars >= englishWords) return 'zh';
  if (englishWords >= 6 && englishWords >= chineseChars) return 'en';
  if (chineseChars >= 6 && chineseChars >= englishWords * 2) return 'zh';
  if (englishWords >= chineseChars) return 'en';
  return 'zh';
};

const detectPreferredResponseLanguage = (text) => {
  return getExpectedResponseLanguage(text);
};

const getSanitizedTextForLanguageCheck = (text, expectedLanguage = 'zh', prompt = '') => {
  let source = String(text || '');
  const promptEnglishTerms = dedupe(extractEnglishWords(prompt).map((word) => word.toLowerCase()).filter((word) => word.length > 1));
  const promptChineseTerms = dedupe(extractChineseTerms(prompt));

  if (expectedLanguage === 'en') {
    dedupe([...COMMON_CHINESE_TERMS_ALLOWED_IN_EN, ...promptChineseTerms]).forEach((term) => {
      source = source.replace(new RegExp(escapeRegExp(term), 'g'), ' ');
    });
  }

  if (expectedLanguage === 'zh') {
    dedupe([...COMMON_ENGLISH_TERMS_ALLOWED_IN_ZH, ...promptEnglishTerms]).forEach((term) => {
      source = source.replace(new RegExp(`\\b${escapeRegExp(term)}\\b`, 'gi'), ' ');
    });
  }

  return source;
};

const detectDominantLanguage = (text, expectedLanguage = 'zh', prompt = '') => {
  const source = getSanitizedTextForLanguageCheck(text, expectedLanguage, prompt);

  const { chineseChars, englishWords } = getLanguageStats(text);
  const sanitizedStats = getLanguageStats(source);

  if (!chineseChars && !englishWords) return 'unknown';
  if (sanitizedStats.englishWords > 0 && sanitizedStats.chineseChars === 0) return 'en';
  if (sanitizedStats.chineseChars > 0 && sanitizedStats.englishWords === 0) return 'zh';
  if (sanitizedStats.englishWords >= Math.max(4, sanitizedStats.chineseChars)) return 'en';
  if (sanitizedStats.chineseChars >= Math.max(4, sanitizedStats.englishWords)) return 'zh';
  return englishWords >= chineseChars ? 'en' : 'zh';
};

const getLanguageSystemPrompt = (text) => {
  const lang = getExpectedResponseLanguage(text);
  if (lang === 'en') {
    return 'Target reply language: English. Write the full answer in English only. Never switch to Chinese except when copying Chinese platform names or quoted user terms exactly as written in the question.';
  }
  return '目标回复语言：中文。整段回答必须使用中文。除题目中原样出现的英文平台名、专有名词或指标缩写外，不要切换为英文句子。';
};

const getRetryLanguageSystemPrompt = (text) => {
  const lang = getExpectedResponseLanguage(text);
  if (lang === 'en') {
    return 'The previous draft used the wrong language. Rewrite the full answer in English only. Remove all Chinese sentences and keep Chinese only if you must preserve platform names copied from the question.';
  }
  return '上一轮输出语言错误。本轮必须改为全中文回答。删除英文句子，仅保留题目中必须原样保留的平台名、专有名词或指标缩写。';
};

const getBaseSystemPrompt = (text) => {
  const lang = getExpectedResponseLanguage(text);
  return lang === 'en' ? SYSTEM_PROMPT_EN : SYSTEM_PROMPT_ZH;
};

const getForceEcommerceSystemPrompt = (text) => {
  const lang = getExpectedResponseLanguage(text);
  return lang === 'en' ? FORCE_ECOMMERCE_SYSTEM_EN : FORCE_ECOMMERCE_SYSTEM_ZH;
};

const getScopeClassificationSystemPrompt = (text) => {
  const lang = getExpectedResponseLanguage(text);
  return lang === 'en' ? SCOPE_CLASSIFICATION_SYSTEM_EN : SCOPE_CLASSIFICATION_SYSTEM_ZH;
};

const getSafetyClassificationSystemPrompt = (text) => {
  const lang = getExpectedResponseLanguage(text);
  return lang === 'en' ? SAFETY_CLASSIFICATION_SYSTEM_EN : SAFETY_CLASSIFICATION_SYSTEM_ZH;
};

const getType2RefusalMessage = (text) => {
  const lang = getExpectedResponseLanguage(text);
  return lang === 'en' ? REFUSAL_MESSAGES.type2.en : REFUSAL_MESSAGES.type2.zh;
};

const getType4RefusalMessage = (text) => {
  const lang = getExpectedResponseLanguage(text);
  return lang === 'en' ? REFUSAL_MESSAGES.type4.en : REFUSAL_MESSAGES.type4.zh;
};

const REFUSAL_MESSAGES = {
  type1: {
    zh: '这个问题涉及政治和社会秩序，超出我的专业范围。我专注于电商及数字零售领域的研究。',
    en: 'This question involves politics and social order, which is outside my scope. I focus on e-commerce and digital retail.'
  },
  type2: {
    zh: '我很抱歉，我不能回答这个问题。我的职责是提供与电商及数字零售相关的专业知识和信息。如果你有其他与电商及数字零售相关的问题，我会很乐意帮助你。',
    en: 'I’m sorry, I can’t answer that. My role is to provide professional knowledge about e-commerce and digital retail. If you have other e-commerce or digital retail questions, I’m happy to help.'
  },
  type3: {
    zh: '我很抱歉，我不能回答这个问题。我的职责是提供与电商及数字零售相关的专业知识和信息。如果你有其他与电商及数字零售相关的问题，我会很乐意帮助你。',
    en: 'I’m sorry, I can’t answer that. My role is to provide professional knowledge about e-commerce and digital retail. If you have other e-commerce or digital retail questions, I’m happy to help.'
  },
  type4: {
    zh: '我只能回答电商及数字零售相关问题，这个问题不在范围内。',
    en: 'I only answer e-commerce and digital retail questions. This topic is out of scope.'
  },
  type5: {
    zh: '当前问题中的关键信息不准确或不明确，我无法提供可靠回答。请补充清晰、准确的信息后再提问。',
    en: 'The key information in this request is inaccurate or unclear, so I can’t provide a reliable answer. Please provide clear and accurate details and ask again.'
  }
};

export const getRefusalCategory = (text) => {
  const source = String(text || '').trim();
  if (!source) return null;

  if (
    source === REFUSAL_MESSAGES.type1.zh ||
    source === REFUSAL_MESSAGES.type1.en ||
    /政治和社会秩序|politics and social order/i.test(source)
  ) {
    return 'type1';
  }

  if (
    source === REFUSAL_MESSAGES.type5.zh ||
    source === REFUSAL_MESSAGES.type5.en ||
    /不准确或不明确|inaccurate or unclear|reliable answer/i.test(source)
  ) {
    return 'type5';
  }

  if (
    source === REFUSAL_MESSAGES.type4.zh ||
    source === REFUSAL_MESSAGES.type4.en ||
    /out of scope|对于该问题我不太了解|不在范围内|consult a relevant professional/i.test(source)
  ) {
    return 'type4';
  }

  if (
    source === REFUSAL_MESSAGES.type2.zh ||
    source === REFUSAL_MESSAGES.type2.en ||
    /can['’]t answer that|不能回答这个问题/i.test(source)
  ) {
    return 'type2';
  }

  return null;
};

const isIntroductoryResponse = (text) => {
  const source = String(text || '').trim();
  if (!source) return false;
  return /^(你好|您好)[！!,.，\s]*我是.*(SealSeek|玺承)/i.test(source) ||
    /^(hello|hi)[!,. ]*(i am|i['’]m).*sealseek/i.test(source) ||
    /有什么可以帮助你的吗[？?]?$/i.test(source) ||
    /how can i help you\??$/i.test(source);
};

const isWrongLanguageResponse = (prompt, response) => {
  const expectedLanguage = getExpectedResponseLanguage(prompt);
  const actualLanguage = detectDominantLanguage(response, expectedLanguage, prompt);
  const sanitized = getSanitizedTextForLanguageCheck(response, expectedLanguage, prompt).trim();
  const firstVisibleChar = sanitized.charAt(0);
  const { chineseChars, englishWords } = getLanguageStats(sanitized);

  if (expectedLanguage === 'en') {
    return /^[\u4e00-\u9fff]/.test(firstVisibleChar) ||
      (actualLanguage === 'zh' && chineseChars >= 2) ||
      (chineseChars >= 4 && englishWords < chineseChars);
  }

  return /^[A-Za-z]/.test(firstVisibleChar) ||
    (actualLanguage === 'en' && englishWords >= 3) ||
    (englishWords >= 6 && chineseChars <= englishWords);
};

const getRetrySystemPrompts = (prompt, response, previousPrompts = []) => {
  const lang = getExpectedResponseLanguage(prompt);
  const retryPrompts = [];
  const refusalCategory = getRefusalCategory(response);

  if (shouldForceEcommerceAnswer(prompt) && refusalCategory === 'type4') {
    retryPrompts.push(lang === 'en' ? RETRY_FORCE_ANSWER_EN : RETRY_FORCE_ANSWER_ZH);
  }

  if (isIntroductoryResponse(response)) {
    retryPrompts.push(lang === 'en' ? RETRY_DIRECT_OUTPUT_EN : RETRY_DIRECT_OUTPUT_ZH);
  }

  if (isWrongLanguageResponse(prompt, response)) {
    retryPrompts.push(getRetryLanguageSystemPrompt(prompt));
  }

  return dedupe([...previousPrompts, ...retryPrompts]);
};

const buildMessages = (prompt, extraSystemPrompts = []) => {
  const messages = [
    { role: 'system', content: getBaseSystemPrompt(prompt) },
    { role: 'system', content: getLanguageSystemPrompt(prompt) }
  ];

  if (shouldForceEcommerceAnswer(prompt)) {
    messages.push({ role: 'system', content: getForceEcommerceSystemPrompt(prompt) });
  }

  extraSystemPrompts.forEach((content) => {
    messages.push({ role: 'system', content });
  });

  messages.push({
    role: 'user',
    content: prompt
  });

  return messages;
};

// 问题分类及对应的拒答回复（仅用于极端敏感内容的前端拦截）
const SENSITIVE_CATEGORIES = {
  // 意识形态类别（政治、社会秩序等）
  IDEOLOGY: {
    keywords: [
      '煽动国家分裂', '破坏祖国统一', '颠覆国家政权', '推翻政权',
      'subvert state power', 'overthrow the government', 'violent revolution',
      'secession', 'split the country', 'anti-government uprising'
    ],
    patterns: [
      /\b(overthrow|topple|subvert)\s+(the\s+)?(government|state|regime)\b/i,
      /\b(secession|separatism|split\s+the\s+country)\b/i,
      /\bincite\s+(political\s+)?violence\b/i
    ],
    responses: {
      zh: '这个问题涉及政治和社会秩序，超出我的专业范围。我专注于电商及数字零售领域的研究。',
      en: 'This question involves politics and social order, which is outside my scope. I focus on e-commerce and digital retail.'
    }
  },

  // 违法犯罪类别
  ILLEGAL: {
    keywords: [
      '制造爆炸', '贩卖毒品', '洗钱', '破解银行', '黑客入侵',
      '传播虚假新闻', '制造谣言', '非法色情', '暴力内容',
      '刷单', '补单', '虚假交易', '伪造评价', '刷评价', '刷好评', '删差评',
      '骗补', '骗赔', '薅赔付', '规避平台规则', '规避风控', '店群作弊', '黑搜',
      '作弊', '欺骗平台', '欺骗消费者', '灰产', '恶意套利', '套补贴', '套赔付',
      '不正当', '不合规玩法', '违规玩法', '规避办法', '作弊玩法', '灰产玩法',
      '强制使用平台服务', '指定物流', '指定仓储', '指定erp', '霸王条款', '二选一', '强制搭售',
      '滥用平台优势', '不合理收费', '强制收费', '限定交易', '排他条款',
      'make a bomb', 'build a bomb', 'explosive device', 'buy drugs', 'sell drugs',
      'money laundering', 'hack bank', 'hack account', 'phishing', 'ransomware',
      'fake news', 'spread rumors', 'violent attack',
      'fake orders', 'brush sales', 'brushing orders', 'fabricated transactions', 'fake reviews',
      'subsidy fraud', 'compensation fraud', 'evade platform rules', 'evade risk control', 'store network cheating',
      'cheating', 'deceive the platform', 'deceive consumers', 'gray hat', 'grey hat', 'abusive arbitrage',
      'improper', 'non-compliant tactic', 'rule-bypass method', 'cheat tactic',
      'forced platform services', 'mandated logistics', 'mandated warehousing', 'mandated erp',
      'abusive clause', 'exclusive dealing', 'forced bundling', 'abuse of platform power'
    ],
    patterns: [
      /\b(how\s+to\s+)?(make|build|assemble)\s+(a\s+)?(bomb|explosive|ied)\b/i,
      /\b(buy|sell|traffic|manufacture)\s+(drugs?|narcotics?)\b/i,
      /\b(money\s+launder(ing)?|launder\s+money)\b/i,
      /\b(hack|crack|breach)\s+(a\s+)?(bank|banking|account|system|server)\b/i,
      /\b(create|write|deploy)\s+(malware|ransomware|phishing)\b/i,
      /\b(spread|create)\s+(fake\s+news|rumou?rs?)\b/i,
      /(刷单|补单|虚假交易|伪造评价|刷评价|刷好评|删差评|骗补|骗赔|薅赔付|规避平台规则|规避风控|店群作弊|黑搜|作弊|欺骗平台|欺骗消费者|灰产|恶意套利|套补贴|套赔付|不正当|不合规玩法|违规玩法|规避办法|作弊玩法|灰产玩法|强制使用平台服务|指定物流|指定仓储|指定erp|霸王条款|二选一|强制搭售|滥用平台优势|不合理收费|强制收费|限定交易|排他条款)/i,
      /((设计|生成|策划|提供|给我|帮我写|想|做|起草).{0,16}(不正当|违规|作弊|规避|灰产|欺骗|霸王|强制|排他|二选一|搭售|限定交易))|((不正当|违规|作弊|规避|灰产|欺骗|霸王|强制|排他|二选一|搭售|限定交易).{0,16}(方案|方法|话术|工具|流程|策略|技巧|东西|条款|协议))/i,
      /(商家.{0,16}(必须|只能|不得不).{0,20}(使用|接入|采购|开通).{0,20}(平台指定|指定的).{0,20}(物流|仓储|erp|系统|服务))/i,
      /\b(fake\s+orders?|brush(?:ing)?\s+sales|brush(?:ing)?\s+orders|fabricated\s+transactions?|fake\s+reviews?)\b/i,
      /\b(subsidy\s+fraud|compensation\s+fraud|evade\s+platform\s+rules|evade\s+risk\s+control|store\s+network\s+cheating|cheating|deceiv(?:e|ing)\s+(?:the\s+)?platform|deceiv(?:e|ing)\s+consumers|gray\s+hat|grey\s+hat|abusive\s+arbitrage|improper|non-compliant\s+tactic|rule-bypass\s+method|cheat\s+tactic)\b/i,
      /\b(design|generate|plan|provide|create|write|give)\b.{0,20}\b(improper|illicit|non-compliant|cheat(?:ing)?|deceptive|gray[\s-]?hat|rule[-\s]?bypass)\b/i,
      /\b(improper|illicit|non-compliant|cheat(?:ing)?|deceptive|gray[\s-]?hat|rule[-\s]?bypass|abusive|exclusive|forced\s+bundling)\b.{0,20}\b(scheme|method|script|tool|workflow|strategy|tactic|thing|clause|agreement)\b/i,
      /\b(draft|write|create)\b.{0,24}\b(abusive|exclusive|forced|bundled|coercive)\b.{0,16}\b(clause|agreement|term|policy)\b/i,
      /\bmerchants?\b.{0,20}\b(must|shall|required\s+to)\b.{0,24}\b(use|adopt|purchase)\b.{0,24}\b(platform[-\s]?designated|designated)\b.{0,20}\b(logistics|warehousing|erp|system|service)\b/i
    ],
    responses: {
      zh: '我很抱歉，我不能回答这个问题。我的职责是提供与电商及数字零售相关的专业知识和信息。如果你有其他与电商及数字零售相关的问题，我会很乐意帮助你。',
      en: 'I’m sorry, I can’t answer that. My role is to provide professional knowledge about e-commerce and digital retail. If you have other e-commerce or digital retail questions, I’m happy to help.'
    }
  },

  // 歧视类别
  DISCRIMINATION: {
    keywords: [
      '如何侮辱', '如何嘲讽', '歧视性称呼', '杀光',
      'racist slur', 'hate speech', 'how to insult women', 'how to mock disabled', 'kill all'
    ],
    patterns: [
      /\b(racist\s+slur|hate\s+speech)\b/i,
      /\b(how\s+to\s+)?(insult|mock|degrade)\s+(women|men|foreigners|disabled|muslims|christians|jews|asians|blacks)\b/i,
      /\bkill\s+all\s+(women|men|foreigners|muslims|christians|jews|asians|blacks)\b/i,
      /\bdiscriminat(e|ion)\s+against\b/i
    ],
    responses: {
      zh: '我很抱歉，我不能回答这个问题。我的职责是提供与电商及数字零售相关的专业知识和信息。如果你有其他与电商及数字零售相关的问题，我会很乐意帮助你。',
      en: 'I’m sorry, I can’t answer that. My role is to provide professional knowledge about e-commerce and digital retail. If you have other e-commerce or digital retail questions, I’m happy to help.'
    }
  }
};

// 检查是否包含极端敏感内容（仅前端快速拦截，主要判断由AI完成）
const checkSensitiveContent = (text) => {
  const source = String(text || '');
  const sourceLower = source.toLowerCase();
  const normalizedText = sourceLower.replace(/\s+/g, '').replace(/[，。？！、,.!?;:()[\]{}"'`]/g, '');
  const preferredLanguage = detectPreferredResponseLanguage(source) === 'en' ? 'en' : 'zh';
  const normalizeKeyword = (value) =>
    String(value || '')
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/[，。？！、,.!?;:()[\]{}"'`]/g, '');

  const hitCategory = (category) => {
    for (const keyword of category.keywords || []) {
      if (normalizedText.includes(normalizeKeyword(keyword))) {
        return true;
      }
    }
    for (const pattern of category.patterns || []) {
      if (pattern.test(sourceLower)) {
        return true;
      }
    }
    return false;
  };

  // 检查意识形态类别
  if (hitCategory(SENSITIVE_CATEGORIES.IDEOLOGY)) {
    return SENSITIVE_CATEGORIES.IDEOLOGY.responses[preferredLanguage];
  }

  // 检查违法犯罪类别
  if (hitCategory(SENSITIVE_CATEGORIES.ILLEGAL)) {
    return SENSITIVE_CATEGORIES.ILLEGAL.responses[preferredLanguage];
  }

  // 检查歧视类别
  if (hitCategory(SENSITIVE_CATEGORIES.DISCRIMINATION)) {
    return SENSITIVE_CATEGORIES.DISCRIMINATION.responses[preferredLanguage];
  }

  // 返回null表示没有检测到极端敏感内容，交由AI判断
  return null;
};

const buildRequestBody = (prompt, options = {}, extraSystemPrompts = [], stream = false) => ({
  model: options.model || 'qwen-plus', // 可选: qwen-turbo, qwen-plus, qwen-max
  messages: buildMessages(prompt, extraSystemPrompts),
  // 默认低随机性，提升稳定性；允许通过 options 覆写
  temperature: options.temperature ?? 0.2,
  top_p: options.top_p ?? 0.9,
  ...(options.max_tokens !== undefined && { max_tokens: options.max_tokens }),
  ...options.parameters,
  ...(stream ? { stream: true } : {})
});

const buildScopeClassificationRequestBody = (prompt, options = {}) => ({
  model: options.model || 'qwen-plus',
  messages: [
    { role: 'system', content: getScopeClassificationSystemPrompt(prompt) },
    { role: 'user', content: prompt }
  ],
  temperature: 0,
  top_p: 0.1,
  max_tokens: 8
});

const buildSafetyClassificationRequestBody = (prompt, options = {}) => ({
  model: options.model || 'qwen-plus',
  messages: [
    { role: 'system', content: getSafetyClassificationSystemPrompt(prompt) },
    { role: 'user', content: prompt }
  ],
  temperature: 0,
  top_p: 0.1,
  max_tokens: 8
});

const extractAssistantMessage = (data) => {
  if (data.choices && data.choices.length > 0 && data.choices[0].message) {
    return data.choices[0].message.content;
  }
  if (data.output && data.output.choices && data.output.choices.length > 0) {
    return data.output.choices[0].message.content;
  }

  console.error('API响应格式异常，完整响应:', JSON.stringify(data, null, 2));
  throw new Error('API响应格式异常: ' + JSON.stringify(data));
};

const requestCompletion = async (requestBody) => {
  const response = await fetch(XC_SEALSEEK_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${XC_SEALSEEK_API_KEY}`
    },
    body: JSON.stringify(requestBody)
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const errorMessage = errorData.message || errorData.error?.message ||
      `API请求失败: ${response.status} ${response.statusText}`;
    console.error('API请求失败:', {
      status: response.status,
      statusText: response.statusText,
      errorData
    });
    throw new Error(errorMessage);
  }

  const data = await response.json();
  console.log('API响应数据:', data);
  return extractAssistantMessage(data);
};

const parseScopeClassification = (text) => {
  const normalized = String(text || '').trim().toUpperCase();
  if (normalized === 'ALLOW') return 'allow';
  if (normalized === 'REFUSE') return 'refuse';
  return 'refuse';
};

const parseSafetyClassification = (text) => {
  const normalized = String(text || '').trim().toUpperCase();
  if (normalized === 'SAFE') return 'safe';
  if (normalized === 'UNSAFE') return 'unsafe';
  return 'unsafe';
};

const resolvePromptSafety = async (prompt, options = {}) => {
  const safetyResult = await requestCompletion(buildSafetyClassificationRequestBody(prompt, options));
  return parseSafetyClassification(safetyResult);
};

const resolvePromptScope = async (prompt, options = {}) => {
  if (isEcommerceQuestion(prompt)) {
    return 'allow';
  }

  const scopeResult = await requestCompletion(buildScopeClassificationRequestBody(prompt, options));
  return parseScopeClassification(scopeResult);
};

const resolveAnswerWithRetries = async (prompt, options = {}) => {
  let retrySystemPrompts = [];
  let answer = '';

  for (let attempt = 0; attempt < 3; attempt += 1) {
    answer = await requestCompletion(buildRequestBody(prompt, options, retrySystemPrompts));
    const nextRetryPrompts = getRetrySystemPrompts(prompt, answer, retrySystemPrompts);

    if (nextRetryPrompts.length === retrySystemPrompts.length) {
      return answer;
    }

    retrySystemPrompts = nextRetryPrompts;
    console.warn('检测到回答质量问题，正在触发重试:', {
      attempt: attempt + 1,
      promptPreview: String(prompt || '').slice(0, 80),
      retrySystemPrompts
    });
  }

  return answer;
};


/**
 * 调用百炼通义千问API
 * @param {string} prompt - 用户输入的提示词
 * @param {Object} options - 可选参数
 * @returns {Promise<string>} - AI返回的文本
 */
export const callSealSeekAPI = async (prompt, options = {}) => {
  try {
    // 敏感内容检测 - 在调用 API 前拦截极端敏感内容
    const sensitiveResponse = checkSensitiveContent(prompt);
    if (sensitiveResponse !== null) {
      return sensitiveResponse;
    }

    // 运行时保护：如果未配置，直接抛错，避免发起无效请求
    if (!XC_SEALSEEK_API_KEY || !XC_SEALSEEK_API_URL) {
      throw new Error('未配置密钥或URL，请在 .env 设置 REACT_APP_XC_SEALSEEK_API_KEY / REACT_APP_XC_SEALSEEK_API_URL 后重启开发服务器并刷新页面');
    }

    const promptSafety = await resolvePromptSafety(prompt, options);
    if (promptSafety !== 'safe') {
      return getType2RefusalMessage(prompt);
    }

    const promptScope = await resolvePromptScope(prompt, options);
    if (promptScope !== 'allow') {
      return getType4RefusalMessage(prompt);
    }

    return await resolveAnswerWithRetries(prompt, options);
  } catch (error) {
    console.error('玺承SealSeekAPI调用错误:', error);
    console.error('错误详情:', {
      message: error.message,
      stack: error.stack
    });
    throw error;
  }
};

/**
 * 流式调用API（如果需要支持流式响应）
 * @param {string} prompt - 用户输入的提示词
 * @param {Function} onChunk - 接收数据块的回调函数
 * @param {Object} options - 可选参数
 */
export const callSealSeekAPIStream = async (prompt, onChunk, options = {}) => {
  try {
    // 敏感内容检测 - 在调用 API 前拦截极端敏感内容
    const sensitiveResponse = checkSensitiveContent(prompt);
    if (sensitiveResponse !== null) {
      // 对于流式响应，也返回拒绝消息
      onChunk({
        choices: [{
          message: {
            content: sensitiveResponse
          }
        }]
      });
      return;
    }

    if (!XC_SEALSEEK_API_KEY || !XC_SEALSEEK_API_URL) {
      throw new Error('未配置密钥或URL，请在 .env 设置 REACT_APP_XC_SEALSEEK_API_KEY / REACT_APP_XC_SEALSEEK_API_URL 后重启开发服务器并刷新页面');
    }

    const promptSafety = await resolvePromptSafety(prompt, options);
    if (promptSafety !== 'safe') {
      onChunk({
        choices: [{
          message: {
            content: getType2RefusalMessage(prompt)
          }
        }]
      });
      return;
    }

    const promptScope = await resolvePromptScope(prompt, options);
    if (promptScope !== 'allow') {
      onChunk({
        choices: [{
          message: {
            content: getType4RefusalMessage(prompt)
          }
        }]
      });
      return;
    }

    const requestBody = buildRequestBody(prompt, options, [], true);

    const response = await fetch(XC_SEALSEEK_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${XC_SEALSEEK_API_KEY}`
      },
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      throw new Error(`API请求失败: ${response.status} ${response.statusText}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value);
      const lines = chunk.split('\n');

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          try {
            const data = JSON.parse(line.slice(6));
            // 支持OpenAI兼容格式和原始格式
            if (data.choices || (data.output && data.output.choices)) {
              onChunk(data);
            }
          } catch (e) {
            // 忽略解析错误
          }
        }
      }
    }
  } catch (error) {
    console.error('玺承SealSeek流式API调用错误:', error);
    throw error;
  }
};
